// @flow weak
// eslint no-underscore-dangle: 0

window.__storage = {
  data: {},
};

const StorageService = {
  clear: async () => {
    window.__storage = {
      data: {},
    };
  },
  getItem: async (key = '') => window.__storage.data[key],
  setItem: async (key = '', item) => {
    window.__storage.data[key] = item;
  },
  removeItem: async (key = '') => {
    if (!window.__storage.data[key]) {
      return;
    }

    delete window.__storage.data[key];
  },
};

export default StorageService;
